import React from "react";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../../../constant/TYPE";
import Button from "../../../../../../../common/Button";

const ArrowKeyset = ( props ) => {

  const answerEditor = useSelector( state => state.answerEditor );

  return (
    <table className="key_tbl" summary="키패드">
      <tbody>
      <tr>
        <td>
          <Button latex={ TYPE.KEY_STROKE.LEFT } disabled={ ! answerEditor.isShow } onClick={ props.onKey }>
            <img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_left.svg` } alt=""/>
          </Button>
        </td>
        <td>
          <Button latex={ TYPE.KEY_STROKE.RIGHT } disabled={ ! answerEditor.isShow } onClick={ props.onKey }>
            <img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_right.svg` } alt=""/>
          </Button>
        </td>
      </tr>
      </tbody>
    </table>
  );

};

export default ArrowKeyset;
